module.exports = __webpack_public_path__ + "static/media/agalerija_2023 (35).36fb281c.png";